import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=8d80f098"
import script from "./CreateEvent.vue?vue&type=script&lang=js"
export * from "./CreateEvent.vue?vue&type=script&lang=js"
import style0 from "./CreateEvent.vue?vue&type=style&index=0&id=8d80f098&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d80f098')) {
      api.createRecord('8d80f098', component.options)
    } else {
      api.reload('8d80f098', component.options)
    }
    module.hot.accept("./CreateEvent.vue?vue&type=template&id=8d80f098", function () {
      api.rerender('8d80f098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CreateEvent.vue"
export default component.exports